import React from "react";
import TransactionList from "../../components/TransactionList";

function TransactionHistory() {
    return (
        <div className="relative min-h-screen h-full pb-16 lg:pb-[100px]">
            <div className="max-w-container px-3 lg:px-[25px] xl:px-[33px] m-auto">

                <div className="mt-11 mb-6 md:mb-[60px]">
                    <div className="flex items-center justify-between gap-4 flex-col md:flex-row">

                        <div className="flex flex-wrap lg:flex-nowrap gap-[10px] *:h-12">
                            <div className="px-3 py-[10px] rounded-xl flex items-center text-sm lg:text-base font-medium bg-[#50FDDB]/10 text-[#50FDDB]">
                                All Transactions
                            </div>
                            <div className="px-3 py-[10px] rounded-xl flex items-center text-sm lg:text-base font-medium bg-[#1A1A1A] text-primaryWhite/40">
                                Unstake
                            </div>
                        </div>
                    </div>
                </div>
                <TransactionList />
            </div>
        </div>
    );
}

export default TransactionHistory;
